<template>
<div id="container">
    <div id="main-container">
        <div id="screen-share-btn-container" class="col-2 float-right text-right mt-2">
            <button id="screen-share-btn"  type="button" class="btn btn-lg">
                <i id="screen-share-icon" class="fas fa-share-square"></i>
            </button>
        </div>
        <div id="buttons-container" class="row justify-content-center mt-3">
            <div class="col-md-2 text-center">
                <button id="mic-btn" type="button" class="btn btn-block btn-dark btn-lg">
                    <i id="mic-icon" class="fas fa-microphone"></i>
                </button>
            </div>
            <div class="col-md-2 text-center">
                <button id="video-btn"  type="button" class="btn btn-block btn-dark btn-lg">
                    <i id="video-icon" class="fas fa-video"></i>
                </button>
            </div>
            <div class="col-md-2 text-center">
                <button id="exit-btn"  type="button" class="btn btn-block btn-danger btn-lg">
                    <i id="exit-icon" class="fas fa-phone-slash"></i>
                </button>
            </div>
        </div>
        <div id="full-screen-video"></div>
        <div id="lower-video-bar">
            <div id="remote-streams-container">
                <div id="remote-streams">
                    <!-- insert remote streams dynamically -->
                </div>
            </div>
            <div id="local-stream-container">
                <div id="local-video"></div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'video call',
  data () {
    return {
      micBtnDisabled: false,
      videoBtnDisabled: false,
      screenShareBtn: false,
      exitBtn: false
    }
  },
  created () {

  },
  methods: {

  }
}
</script>

<style scoped>
#buttons-container {
  position: absolute;
  z-index: 2;
  width: 100vw;
}

#full-screen-video {
  position: absolute;
  width: 100vw;
  height: 100vh;
}

#lower-video-bar {
  height: 20vh;
}

#local-stream-container {
  position: relative;
  display: inline-block;
}

.remote-stream-container {
  display: inline-block;
}

#remote-streams {
  height: 100%;
}

#local-video {
  position: absolute;
  z-index: 1;
  height: 20vh;
  max-width: 100%;
}

.remote-video {
  position: absolute;
  z-index: 1;
  height: 100% !important;
  width: 80%;
  max-width: 500px;
}

#mute-overlay {
  position: absolute;
  z-index: 2;
  bottom: 0;
  left: 0;
  color: #d9d9d9;
  font-size: 2em;
  padding: 0 0 3px 3px;
  display: none;
}

.mute-overlay {
  position: absolute;
  z-index: 2;
  top: 2px;
  color: #d9d9d9;
  font-size: 1.5em;
  padding: 2px 0 0 2px;
  display: none;
}

#no-local-video, .no-video-overlay {
  position: absolute;
  z-index: 3;
  width: 100%;
  top: 40%;
  color: #cccccc;
  font-size: 2.5em;
  margin: 0 auto;
  display: none;
}

.no-video-overlay {
  width: 80%;
}

#screen-share-btn-container {
  z-index: 99;
}
</style>
